import { applySnapshot, flow, types } from "mobx-state-tree";
import moment from "moment";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import systemHelperAPI from "../systemhelper/SystemHelperService";
import { PaginationModel } from ".";
import sdgsAPI from "../sdgs/SDGsService";

export const CurrencyRateModel = types
    .model("CurrencyRateModel", {
        currencyCode: customtypes.optional(types.string, ""),
        currencyName: customtypes.optional(types.string, ""),
        currencyRate: customtypes.optional(types.number, 0),
        error: types.optional(ErrorModel, {}),
    })
    .views((self: any) => ({
        get dropdownOption() {
            return {
                key: self.currencyCode,
                text: self.currencyCode,
                value: self.currencyCode,
            };
        },
    }))
    .actions((self: any) => ({
        resetAll: () => {
            applySnapshot(self, {});
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        createCurrencyScreen: flow(function* () {
            try {
                self.loading = true;
                const result = yield systemHelperAPI.createCurrencyScreen(self);
                return result;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        updateCurrencyScreen: flow(function* () {
            try {
                self.loading = true;
                const result = yield systemHelperAPI.updateCurrencyScreen(self);
                return result;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        removeCurrencyScreen: flow(function* () {
            try {
                self.loading = true;
                const result = yield systemHelperAPI.removeCurrencyScreen(self);
                return result;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
    }));
export type ICurrencyRateModel = typeof CurrencyRateModel.Type;

export const CurrencyModel = types
    .model("CurrencyModel", {
        year: customtypes.optional(types.number, 0),
        rateAsOF: customtypes.optional(types.string, ""),
        source: customtypes.optional(types.string, ""),
        remark: customtypes.optional(types.string, ""),
        currency: customtypes.optional(types.array(CurrencyRateModel), []),
        error: types.optional(ErrorModel, {}),
        loading: types.optional(types.boolean, false),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        setAllField: (data: any) => {
            Object.keys(data).forEach((key) => {
                try {
                    self[key] = data[key];
                } catch (e) {
                    console.log("exception on mapping key:", key);
                }
            });
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
        getCurrency: flow(function* (year: number) {
            try {
                self.loading = true;
                const result = yield systemHelperAPI.getCurrency(year);
                self.setAllField(result.data);
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        getCurrencyByIframe: flow(function* (year: number) {
            try {
                self.loading = true;
                const result = yield sdgsAPI.getCurrencyByIframe(year);
                self.setAllField(result.data);
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        updateCurrency: flow(function* () {
            try {
                self.loading = true;
                self.rateAsOF = moment().format("YYYY-MM-DD");
                yield systemHelperAPI.updateCurrency(self);
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),

    }));
export type ICurrencyModel = typeof CurrencyModel.Type;

export const CurrencyScreenListModel = types
    .model("CurrencyScreenListModel", {
        list: types.optional(types.array(CurrencyRateModel), []),
        // paging: types.optional(PaginationModel, {
        //   pageSize: 25,
        // }),
        error: types.optional(ErrorModel, {}),
        loading: types.optional(types.boolean, false),
    })
    .views((self: any) => ({}))
    .actions((self: any) => ({
        get: flow(function* () {
            try {
                self.loading = true;
                const result = yield systemHelperAPI.getCurrencyScreenList();
                self.list = result.data;
                self.error.tigger = false;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        onSelectedFilter: (value: any) => {
            self.setDefaultPagination();
            self.orgTypeCode = value;
            self.searchUser();
        },
        onSearchTextFilter: (value: any) => {
            self.setDefaultPagination();
            self.paging.searchText = value;
            self.searchUser();
        },
        onSelectedPage: (pageNo: number) => {
            self.paging.pageNo = pageNo;
            self.searchUser();
        },
        setPagination: (result: any) => {
            self.paging.pageSize = result.pageSize;
            self.paging.pageNo = result.pageNo;
            self.paging.totalRow = result.totalRow;
        },
        setDefaultPagination: () => {
            self.paging.pageNo = 1;
        },
        resetAll: () => {
            self.list = [];
            self.paging = {};
        },
    }));
export type ICurrencyScreenListModel = typeof CurrencyScreenListModel.Type;